<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{
    errorMessages: (errorMessages$ | async) ?? [],
    feeBasedServicesEnabled: feeBasedServicesEnabled$ | async
  }"
>
</ng-container>

<ng-template
  #template
  let-errorMessages="errorMessages"
  let-feeBasedServicesEnabled="feeBasedServicesEnabled"
>
  <vp-alert-container [alerts]="errorMessages"></vp-alert-container>

  <mat-toolbar>
    <span>{{ props.label }}</span>
    <span mat-spacer></span>
    <button type="button" mat-raised-button color="primary" (click)="addHandler($event)">
      Add Opinion Type
    </button>
  </mat-toolbar>

  <table mat-table flex [dataSource]="(dataSource$ | async) ?? []">
    <ng-container matColumnDef="opinion-type">
      <td mat-cell *matCellDef="let row">
        <table mat-table [dataSource]="row?.servicesTableData">
          <ng-container matColumnDef="serviceFriendlyId">
            <th mat-header-cell *matHeaderCellDef>Service Type</th>
            <td mat-cell *matCellDef="let service">
              @if (feeBasedServiceLookup$(service.friendlyId) | async; as feeBasedService) {
                {{ feeBasedService.displayName }}
              } @else {
                <mat-spinner [diameter]="14"></mat-spinner>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="serviceActive">
            <th mat-header-cell *matHeaderCellDef>Active</th>
            <td mat-cell *matCellDef="let service">
              @if (service.active) {
                <mat-icon color="accent" matTooltip="Active">toggle_on</mat-icon>
              } @else {
                <mat-icon matTooltip="Inactive">toggle_off</mat-icon>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="serviceFee">
            <th mat-header-cell *matHeaderCellDef>Fee</th>
            <td mat-cell *matCellDef="let service">{{ service.fee | currency }}</td>
          </ng-container>

          <ng-container matColumnDef="serviceActions">
            <th mat-header-cell *matHeaderCellDef class="action-header-text">Actions</th>
            <td mat-cell *matCellDef="let service; let i = index">
              <button
                type="button"
                mat-icon-button
                color="primary"
                matTooltip="Edit Service Cost Overide"
                (click)="updateFeeBasedServiceHandler(row, service)"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                type="button"
                mat-icon-button
                color="warn"
                matTooltip="Delete Service Cost Overide"
                (click)="deleteFeeBasedServiceHandler(row, service)"
              >
                <mat-icon>delete_forever</mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="header-opinion-display">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="3">
              >
              @if (caseTypeLookup$(row.caseTypeId) | async; as caseType) {
                {{ "Opinion Type: " + caseType?.displayName }}
              } @else {
                <mat-spinner [diameter]="14"></mat-spinner>
              }
            </th>
          </ng-container>

          <ng-container matColumnDef="header-opinion-actions">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="1" class="action-header-cell">
              @if (feeBasedServicesEnabled) {
                <button
                  type="button"
                  mat-icon-button
                  color="primary"
                  matTooltip="Add Service Cost Override"
                  (click)="addServiceCostOveride(row)"
                >
                  <mat-icon>add service</mat-icon>
                </button>
              }

              <button
                type="button"
                mat-icon-button
                color="warn"
                matTooltip="Delete Opinion and all Overrides"
                (click)="deleteHandler(row)"
              >
                <mat-icon>delete_forever</mat-icon>
              </button>
            </th>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="['header-opinion-display', 'header-opinion-actions']"
          ></tr>

          <tr
            mat-header-row
            *matHeaderRowDef="[
              'serviceFriendlyId',
              'serviceActive',
              'serviceFee',
              'serviceActions'
            ]"
          ></tr>

          <tr
            mat-row
            *matRowDef="
              let service;
              columns: ['serviceFriendlyId', 'serviceActive', 'serviceFee', 'serviceActions']
            "
          ></tr>
        </table>
      </td>
    </ng-container>

    <tr mat-row *matRowDef="let row; columns: ['opinion-type']"></tr>
  </table>
</ng-template>
